<template>
  <div>
      <el-header>
      <el-col :span="2">
        <img
          src="../assets/images/covid19-trans.png"
          width="90"
          height="90"
          style="margin: 8px auto"
        />
      </el-col>
      <el-col :span="4" class="title myfont">
        CoV2-TCR
      </el-col>
      <el-col :span="18">
        <el-row class="myfont" style="font-size:28px; text-align: center;">
          a web server for screening TCR CDR3 recognizing SARS-CoV-2 epitopes from TCR immune repertoire of COVID-19 patients
        </el-row>
        <el-row type="flex" justify="center">
          <el-menu
            router
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#500a16"
            text-color="#fff"
            active-text-color="#FFCC00"
            style="font-weight: bold"
          >
            <el-menu-item index="/">Home</el-menu-item>
            <el-menu-item index="/predict">Binding Predict</el-menu-item>
            <el-menu-item index="/download">Download</el-menu-item>
            <el-menu-item index="/citation">Citation</el-menu-item>
            <el-menu-item index="/contact">Contact</el-menu-item>
          </el-menu>
        </el-row>
      </el-col>
    </el-header>
  </div>
</template>

<script>
export default {
    data(){
      return{
          
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
}
</script>

<style>
.el-header {
    height: 110px !important;
    background-color: #500a16;
    padding: 0 15px;
}
.title {
    font-size: 40px;
    height: 70px;
    line-height: 70px;
    margin: 10px 0 5px 0;
}
.el-menu{
    width: 600px;
    line-height: 50px;
    font-size: 30px;
}
.el-menu.el-menu--horizontal{
    border-bottom: #000;
    padding: 5px auto;
}
.el-menu--horizontal>.el-menu-item {
    height: 45px;
    line-height: 45px;
    margin: 0 auto;
}
</style>